function isLikelyMathBacktickContent(text) {
  return /\\[a-zA-Z]|[=^_{}]|^-?\d+(\.\d+)?$|^[A-Za-z]$/.test(text);
}

function isAlreadyDelimitedMath(text) {
  return (
    /^\\\([\s\S]*\\\)$/.test(text) ||
    /^\\\[[\s\S]*\\\]$/.test(text) ||
    /^\$\$[\s\S]*\$\$$/.test(text) ||
    /^\$[^$\n]+\$$/.test(text)
  );
}

export function normalizeBacktickWrappedMath(text) {
  if (!text || !text.includes('`')) return text;

  let normalized = text
    .replace(/(\$|\\\(|\\\[)`/g, '$1')
    .replace(/`(\$|\\\)|\\\])/g, '$1');

  normalized = normalized.replace(/`([^`]+)`/g, (match, inner) => {
    const candidate = inner.trim();

    if (isAlreadyDelimitedMath(candidate)) {
      return candidate;
    }

    if (isLikelyMathBacktickContent(candidate)) {
      return `$${candidate}$`;
    }

    return match;
  });

  return normalized;
}
